export default __webpack_public_path__ + "static/media/NoirPro-Heavy.49715936.eot";